import { MetaLayerDefinition } from '@agissc/ktag-map';
import escapeRegExp from 'escape-string-regexp';
import { MapTypeCategory } from '../api/Contracts';
import { sortByAtoZtoNumber } from '../../../components/sortOrder';

const getWeight = (layer: MetaLayerDefinition, regex: RegExp) => {
  if (layer.title.match(regex)) return 0;
  if (layer.id?.match(regex)) return 1;
  return 2;
};

const getMatchingText = (layer: MetaLayerDefinition, regex: RegExp) => {
  if (layer.title.match(regex)) return layer.title;
  if (layer.id?.match(regex)) return layer.id;
  if (layer.description?.match(regex)) return layer.description;
  return '';
};

export const filterTopicLayers = (
  topicLayersQuery: Record<string, MetaLayerDefinition> | undefined,
  filterText: string,
) => {
  if (!topicLayersQuery) return [];

  const layerItems = Object.values(topicLayersQuery);
  const filterSanetized = filterText?.trim();

  if (!filterSanetized) {
    return layerItems.sort((a, b) => sortByAtoZtoNumber(a.title, b.title));
  }

  const regex = new RegExp(escapeRegExp(filterSanetized), 'i');
  return layerItems
    .filter(
      (layer) =>
        layer.title.match(regex) ||
        layer.id?.match(regex) ||
        layer.description?.match(regex),
    )
    .sort((a, b) => {
      const weightDiff = getWeight(a, regex) - getWeight(b, regex);
      if (weightDiff !== 0) {
        return weightDiff;
      }

      const aPosition = a.title.search(regex);
      const bPosition = b.title.search(regex);

      if (aPosition !== bPosition) {
        return aPosition - bPosition;
      }

      const aText = getMatchingText(a, regex);
      const bText = getMatchingText(b, regex);

      return sortByAtoZtoNumber(aText, bText);
    });
};

const filterTopicLayersByIds = (
  topicLayersQuery: Record<string, MetaLayerDefinition>,
  ids: string[],
) =>
  !topicLayersQuery || !ids
    ? []
    : Object.values(ids).reduce((acc: MetaLayerDefinition[], id) => {
        const layer = topicLayersQuery[id];
        if (layer) {
          acc.push(layer);
        }
        return acc;
      }, []);

export const getFavouritLayers = (
  allLayers: Record<string, MetaLayerDefinition>,
  favoriteIds: string[],
) => filterTopicLayersByIds(allLayers, favoriteIds);

export const getFilteredTopics = (
  allLayers: Record<string, MetaLayerDefinition>,
  filterText: string,
  categories: string[] = [...MapTypeCategory].map(([key]) => key),
) => {
  const layers = filterTopicLayers(allLayers, filterText);
  return layers.filter((item) => categories.includes(item.source));
};
